import { createApp, defineAsyncComponent } from 'vue'


import platform from 'platform'
import axios from 'axios'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({apiKey: 'b3ec68154b90832d01d171fb97a22d1e', plugins: [new BugsnagPluginVue()]})
const bugsnag = Bugsnag.getPlugin('vue')

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementsByTagName("meta")['csrf-token'].getAttribute('content')
window.analytics = require('./analytics.js')
window.Countries = require('./countries')

window.parseError = function(error) {
    if (error && error.response && error.response.status && window.bugsnagClient) {
        if (
            (window.axios && !window.axios.isCancel(error)) 
            && error.response.status != 401 
            && error.response.status != 403
            && error.response.status != 419
            && error.response.status != 422
        ) {
            Bugsnag.notify(error)
        }
    }

    return error && error.response && error.response.data ? error.response.data : ''
}

import store from './front/forms/store'
import validator from './validator'
import { createI18n } from 'vue-i18n'
import messages from './front/trans.en.js'

const i18n = createI18n({legacy: true, locale: 'en', messages: messages})

const Engagement        = defineAsyncComponent(() => import('./front/forms/Engagement'))
const WebEngagement     = defineAsyncComponent(() => import('./front/forms/WebEngagement'))
const PreviewEngagement = defineAsyncComponent(() => import('./front/forms/PreviewEngagement'))
const ApiEngagement     = defineAsyncComponent(() => import('./front/forms/ApiEngagement'))
const CfsEngagement     = defineAsyncComponent(() => import('./front/forms/CfsEngagement'))
const CfsWebEngagement  = defineAsyncComponent(() => import('./front/forms/CfsWebEngagement'))

const app = createApp({
    created() {
        store.dispatch('initialize', window._data)
    },
    mounted() {
        if (platform.name == 'Safari' || platform.name == 'Opera') {
            window.matchMedia("print").addListener((value) => { 
                if (value.matches) {
                    store.commit('SET_PRINTING', true) 
                } else {
                    store.commit('SET_PRINTING', false)
                }
            })
        } else {
            window.onbeforeprint = () => { store.commit('SET_PRINTING', true) }
            window.onafterprint  = () => { store.commit('SET_PRINTING', false) }
        }
        if (window.analytics && window._data && window._data.analytics) {
            setTimeout(() => {
                analytics.set(window._data.analytics[0], window._data.analytics[1], window._data.analytics[2])
            }, 1000)
        }
    },
    components: {
        'engagement': Engagement,
        'web-engagement': WebEngagement,
        'api-engagement': ApiEngagement,
        'cfs-engagement': CfsEngagement,
        'cfs-web-engagement': CfsWebEngagement,
        'preview-engagement': PreviewEngagement,
    }
})

import Icon from './front/components/Icon'
app.component('app-icon', Icon)

import Button from './front/components/Button'
app.component('app-button', Button)

app.use(store)
app.use(i18n)
app.use(validator)
app.use(bugsnag)

app.mount('#app')

window.store = store
